import { createContext, useContext } from "react"

// Per-request CSP nonce from entry.server.tsx; undefined on the client, where browsers hide nonce attributes
export const NonceContext = createContext<string | undefined>(undefined)

export const NonceProvider = NonceContext.Provider

export function useNonce() {
  return useContext(NonceContext)
}
